<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProductListPagination',
  computed: mapGetters({
    pagination: 'search/pagination',
  }),
  methods: {
    isCurrent(number) {
      return number === this.pagination.current;
    },
  },
};
</script>

<template>
  <div class="flex justify-end" v-if="pagination.total_pages > 1">
    <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
      <router-link
        :to="{ query: { ...$route.query, page: 1 } }"
        :class="{
          'text-gray-500': pagination.prev,
          'text-gray-300 cursor-not-allowed pointer-events-none': !pagination.prev
        }"
        class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300
        bg-white text-xs font-medium hover:bg-gray-50"
      >
        <i class="fas fa-angle-double-left mx-2"></i>
      </router-link>
      <router-link
        :to="{ query: { ...$route.query, page: pagination.prev } }"
        :class="{
          'text-gray-500': pagination.prev,
          'text-gray-300 cursor-not-allowed pointer-events-none': !pagination.prev }"
        class="relative inline-flex items-center px-2 py-2 border border-gray-300
          bg-white text-xs font-medium hover:bg-gray-50">
        <i class="fas fa-angle-left mx-2"></i>
      </router-link>

      <router-link
        :to="{ query: { ...$route.query, page: page } }"
        v-for="page in pagination.pages"
        :key="page"
        :class="{
          'pagination-active-page': isCurrent(page),
          'pagination-page': !isCurrent(page)
        }"
      >
        {{page}}
      </router-link>

      <router-link
        :to="{ query: { ...$route.query, page: pagination.next } }"
        :class="{
          'text-gray-500': pagination.next,
          'text-gray-300 cursor-not-allowed pointer-events-none': !pagination.next
        }"
        class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white
          text-xs font-medium hover:bg-gray-50"
      >
        <i class="fas fa-angle-right mx-2"></i>
      </router-link>
      <router-link
        :to="{ query: { ...$route.query, page: pagination.total_pages } }"
        :class="{
           'text-gray-500': pagination.next,
           'text-gray-300 cursor-not-allowed pointer-events-none': !pagination.next
          }"
        class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300
        bg-white text-xs font-medium hover:bg-gray-50"
      >
        <i class="fas fa-angle-double-right mx-2"></i>
      </router-link>
    </nav>
  </div>
</template>

<style>
.pagination-active-page {
  @apply z-10 bg-orange-50 border-orange-500 text-orange-diagomics-light
  relative inline-flex items-center px-4 py-2 border text-xs font-medium;
}

.pagination-page {
  @apply bg-white border-gray-300 text-gray-500 hover:bg-gray-50
  relative inline-flex items-center px-4 py-2 border text-xs font-medium;
}
</style>
